import { render, staticRenderFns } from "./ResetPasswordPopup.vue?vue&type=template&id=4167ea72"
import script from "./ResetPasswordPopup.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports